/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import WasterecordQueryResult from './WasterecordQueryResult';

/**
 * The WasterecordOutputCmsRecord model module.
 * @module model/WasterecordOutputCmsRecord
 * @version 1.0
 */
class WasterecordOutputCmsRecord {
    /**
     * Constructs a new <code>WasterecordOutputCmsRecord</code>.
     * @alias module:model/WasterecordOutputCmsRecord
     */
    constructor() { 
        
        WasterecordOutputCmsRecord.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>WasterecordOutputCmsRecord</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/WasterecordOutputCmsRecord} obj Optional instance to populate.
     * @return {module:model/WasterecordOutputCmsRecord} The populated <code>WasterecordOutputCmsRecord</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new WasterecordOutputCmsRecord();

            if (data.hasOwnProperty('record')) {
                obj['record'] = WasterecordQueryResult.constructFromObject(data['record']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/WasterecordQueryResult} record
 */
WasterecordOutputCmsRecord.prototype['record'] = undefined;






export default WasterecordOutputCmsRecord;

